var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwitch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.4995 14.2536C22.4995 16.3535 21.2396 16.5034 20.9996 16.5034H2.55798L6.52529 12.5361L5.46784 11.4712L0.218099 16.7209C-0.0726996 17.0135 -0.0726996 17.4858 0.218099 17.7784L5.46784 23.0281L6.52529 21.9707L2.55798 18.0034H20.9996C22.0345 18.0034 23.9994 17.2534 23.9994 14.2536V12.0037H22.4995V14.2536Z",
    fill: "#BEBEBE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.50218 9.75375C1.50218 7.65385 2.76212 7.50386 3.00211 7.50386H21.4437L17.4764 11.4712L18.5338 12.5286L23.7836 7.27887C24.0744 6.98634 24.0744 6.51396 23.7836 6.22142L18.5338 0.97168L17.4689 2.03663L21.4437 6.00393H3.00211C1.96716 6.00393 0.0022583 6.7539 0.0022583 9.75375V12.0036H1.50218V9.75375Z",
    fill: "#BEBEBE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitch);
export default __webpack_public_path__ + "static/media/switch.ba06173e882f07bbc120e7702dd47f27.svg";
export { ForwardRef as ReactComponent };